import 'reflect-metadata';
import {jsonObject, jsonMember, jsonArrayMember} from 'typedjson';

import {CertificateIssuerDetails} from '@/model/system/certificate/certificateIssuerDetails';

@jsonObject
export class CertificateDetails {

  @jsonMember({name: 'content'})
  public Content!: string;

  @jsonMember({name: 'publicKey'})
  public PublicKey!: string;

  @jsonMember({name: 'startDate'})
  public StartDate!: string;

  @jsonMember({name: 'endDate'})
  public EndDate!: string;

  @jsonMember({name: 'issuerDetails'})
  public IssuerDetails!: CertificateIssuerDetails;

  @jsonArrayMember(String, {name: 'dnss'})
  public Dnss!: string[];
}
